import React from 'react';
import { Link } from 'react-router-dom';
import { useConsent } from '@/features/consent/hooks/useConsent';
import { COOKIE_CATEGORIES } from '@/features/consent/data/cookiePolicy';
import { useShellI18n } from '@/features/language/useI18n';

const CookiePolicyPage: React.FC = () => {
  const { openSettings } = useConsent();
  const { t, formatDate } = useShellI18n();

  return (
    <main className="public-legal-route">
      <div className="legal-route-nav">
        <Link to="/" className="btn ghost sm">
          {t('Back to Portal')}
        </Link>
      </div>
      <div className="legal-page">
        <div className="page-hero">
          <h1 className="page-title">{t('Cookie Policy')}</h1>
          <p className="meta">
            {t('Effective date: {{date}}', { date: formatDate('2026-06-19') })}
          </p>
        </div>

        <section className="legal-section">
          <h2>{t('What are cookies?')}</h2>
          <p>
            {t(
              'Cookies and similar browser storage technologies retain small amounts of information on your device. The Portal uses them for authentication, security, navigation and interface preferences.'
            )}
          </p>
        </section>

        <section className="legal-section">
          <h2>{t('Managing your cookie preferences')}</h2>
          <p>{t('You can update preferences at any time from the cookie settings dialog.')}</p>
          <div className="form-actions">
            <button onClick={openSettings} className="btn secondary" type="button">
              {t('Manage Cookie Preferences')}
            </button>
          </div>
        </section>

        <section className="legal-section">
          <h2>{t('The cookies we use')}</h2>
          {COOKIE_CATEGORIES.map((category) => (
            <article key={category.id} className="legal-section">
              <h3>
                {t(category.name)} {category.required ? t('(Required)') : t('(Optional)')}
              </h3>
              <p>{t(category.description)}</p>
              <div className="table-scroll">
                <table className="policy-table">
                  <thead>
                    <tr>
                      <th>{t('Name')}</th>
                      <th>{t('Provider')}</th>
                      <th>{t('Purpose')}</th>
                      <th>{t('Expiry')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {category.cookies.map((cookie) => (
                      <tr key={cookie.name}>
                        <td>{cookie.name}</td>
                        <td>{t(cookie.provider)}</td>
                        <td>{t(cookie.purpose)}</td>
                        <td>{t(cookie.expiry)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </article>
          ))}
        </section>
      </div>
    </main>
  );
};

export default CookiePolicyPage;
